import { deleteTargetSystem } from "../../../../../actions/Utilities/ConfigureAgreement";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeleteTargetSystem = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteTargetSystem(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetTargetSystem"]);
      toast.fire(
        "Success",
        "Policy Management System were deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Bulk deactivation of Policy Management System failed",
        "Server Error: Cannot deactivate Policy Management System",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteTargetSystem;
